import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";

const RefreshIntervalContext = createContext();

export function useRefreshInterval() {
  return useContext(RefreshIntervalContext);
}

export function RefreshIntervalProvider({ children }) {
  const [interval, setIntervalValue] = useState(15);
  const [isRunning, setIsRunning] = useState(true);

  useEffect(() => {
    const handleIntervalChange = (event) => {
      setIntervalValue(event.detail);
    };

    window.addEventListener("refreshIntervalChange", handleIntervalChange);
    return () => {
      window.removeEventListener("refreshIntervalChange", handleIntervalChange);
    };
  }, []);

  const setInterval = useCallback((newInterval) => {
    setIntervalValue(newInterval);
    window.dispatchEvent(
      new CustomEvent("refreshIntervalChange", { detail: newInterval })
    );
  }, []);

  const toggleRunning = useCallback(() => {
    setIsRunning((prev) => {
      const newValue = !prev;
      window.dispatchEvent(
        new CustomEvent("refreshToggle", { detail: newValue })
      );
      return newValue;
    });
  }, []);

  // Otomatik yenilemeyi deterministik biçimde başlat (toggleRunning mevcut
  // değere bağlı; mount'ta "kesin resumed" için bu kullanılır).
  const resume = useCallback(() => {
    setIsRunning(true);
    window.dispatchEvent(new CustomEvent("refreshToggle", { detail: true }));
  }, []);

  const value = useMemo(() => ({
    interval,
    setInterval,
    isRunning,
    toggleRunning,
    resume,
  }), [interval, setInterval, isRunning, toggleRunning, resume]);

  return (
    <RefreshIntervalContext.Provider value={value}>
      {children}
    </RefreshIntervalContext.Provider>
  );
}
